import React from "react";

const Spinner = () => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center">
      <div className="w-16 h-16 border-4 border-dashed border-purple-600 rounded-full animate-spin"></div>
    </div>
  );
};

export default Spinner;
